window.debugMode && console.log("[cidaas]", "Cidaas JS loaded");

(() => {
  window.login = async () => {
    if (typeof window.cidaasClient !== "undefined") {
      await window.cidaasClient.loginWithBrowser();
    } else {
      window.debugMode &&
        console.error("[cidaas]", "Cidaas Client not initialized");
    }
  };

  async function fetchMultipassToken(url, options = {}) {
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const redirectUrl = data.data.redirectUrl;
      console.log(data.data);
      //window.location.href = redirectUrl;
    } catch (error) {
      console.error(`Fetch error: ${error.message}`);
      throw error; // Rethrow the error so it can be handled by the caller
    }
  }

  function loginCidaas() {
    if (typeof window.cidaasClient !== "undefined") {
      window.debugMode &&
        console.log("[cidaas]", "Start Cidaas Client Login Callback");

      window.cidaasClient
        .loginCallback()
        .then(async function (response) {
          const multipassUrl = window.cidaasVariables.multipass.webservice_url;
          let multipassReturnUrl = window.cidaasVariables.multipass.return_url;
          const urlParams = new URLSearchParams(window.location.search);
          const returnUrl = urlParams.get("return_url");
          if (returnUrl) {
            multipassReturnUrl = returnUrl;
          }
          const fetchUrl = `${multipassUrl}?return_url=${multipassReturnUrl}`;
          const userDetails = await window.cidaasClient.getUserProfile();
          window.debugMode &&
            console.log("[cidaas]", "userDetails", {
              userDetails,
            });
          window.debugMode && console.log("[cidaas]", "Redirect to", fetchUrl);
          
          const multipassToken = await fetchMultipassToken(fetchUrl, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userDetails.access_token}`,
            },
          });
        })
        .catch(function (error) {
          window.debugMode && console.error("[cidaas]", "Login failed");
          window.debugMode && console.error("[cidaas]", error);
        });
    } else {
      window.debugMode &&
        console.error("[cidaas]", "Cidaas Client not initialized");
    }
  }

  if (typeof window.cidaasClient !== "undefined") {
    window.debugMode && console.log("[ciddas]", "Cidaas client available");

    window.cidaasClient
      .getUserInfo()
      .then(async (response) => {
        if (response) {
          window.debugMode && console.log("[ciddas]", "Cidaas user details loaded");
          window.cidaasVariables.user_details = response;

          console.log("[ciddas]", "Cidaas user details loaded", response);
          

          if (window.cidaasVariables?.user_details?.access_token) {
            const userProfile = await window.cidaasClient.getUserProfile({
              access_token: response.access_token,
            }).then((resp) => {
              return resp;
            });

            if (userProfile) {
              window.cidaasVariables.user_profile = userProfile;
              window.debugMode && console.log("[cidaas]", "User profile", userProfile);
            }
          }
          window.dispatchEvent(
            new CustomEvent("cidaas:userDetails", { detail: window.cidaasVariables.user_details })
          );
          
          const userDetails = response;
          const fetchAddServicesUrl = `${window.cidaasVariables.config.authority}/camlog-webhook-srv/additionalservice/addon`
          const addedServices = await fetch(fetchAddServicesUrl, {
            method: 'GET', 
            headers: {
              'Authorization': `Bearer ${userDetails.access_token}` 
            }
          }).then((resp) => {
            return resp.json()
          });

          window.dispatchEvent(
            new CustomEvent("cidaas:additionalServices", { detail: addedServices })
          );
          window.cidaasVariables.additional_services = addedServices;

          window.debugMode && console.log("[cidaas]", "Added services", addedServices);

          const fetchAllImplantPasses = `${window.cidaasVariables.ocr.webservice_url}/implant-srv/implantpasses`
          const implantatPasses = await fetch(fetchAllImplantPasses, {
            method: 'GET', 
            headers: {
              'Authorization': `Bearer ${userDetails.access_token}` 
            }
          }).then((resp) => {
            return resp.json()
          });
          window.cidaasVariables.implant_passes = implantatPasses;


          window.dispatchEvent(
            new CustomEvent("cidaas:implantpasses", { detail: implantatPasses })
          );

          window.debugMode && console.log("[cidaas]", "Implantat passes", implantatPasses);

          window.debugMode &&
            console.log("[ciddas]", "Cidaas id", response?.profile?.sub);

          window.debugMode &&
            console.log(
              "[ciddas]",
              "Cidaas access token",
              response?.access_token ? true : false
            );
        } else if (
          !response &&
          window.cidaasVariables.protected &&
          window.cidaasVariables.shopify.design_mode
        ) {
          window.debugMode &&
            console.log(
              "[ciddas]",
              "Login needed, but is shopify theme customizer "
            );
          window.dispatchEvent(
            new CustomEvent("cidaas:userDetails", { detail: true })
          );
        } else if (!response && window.cidaasVariables.protected) {
          window.debugMode && console.log("[ciddas]", "Login needed");
          await window.cidaasClient.loginWithBrowser();
        } else {
          window.debugMode && console.log("[ciddas]", "User is not logged in");
          /*await window.cidaasClient.loginWithBrowser();*/
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
})();

if (typeof CidaasUserAccount === "undefined") {
  class CidaasUserAccount extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupCidaas();
    }

    setupCidaas() {
      const btn = this.querySelector("a");
      if (btn) {
        btn.addEventListener("click", async (event) => {
          if (window.cidaasVariables?.user_details) {
            window.location.href = btn.getAttribute("href");
          } else {
            event.preventDefault();
            await window.cidaasClient.loginWithBrowser();
            return false;
          }
        });
      }
    }
  }

  if (!window.customElements.get("cidaas-user-account")) {
    window.customElements.define("cidaas-user-account", CidaasUserAccount);
  }
}

if (typeof CidaasLock === "undefined") {
  class CidaasLock extends HTMLElement {
    constructor() {
      super();
      this.attachEventListener();
    }

    connectedCallback() {
      if (this.getAttribute("data-unlocked") == "true") {
        this.showUnlockedContent();
      }
    }

    attachEventListener() {
      window.addEventListener(
        "cidaas:userDetails",
        this.showUnlockedContent.bind(this)
      );
    }

    showUnlockedContent() {
      const skeletonLoader = this.querySelector("cidaas-skeleton");
      const lockedView = this.querySelector("cidaas-locked");
      const unlockedView = this.querySelector("cidaas-unlocked");

      const loggedOutView = this.querySelector("cidaas-logged-out");
      const loggedInView = this.querySelector("cidaas-logged-in");

      if (loggedOutView && loggedInView) {
        loggedOutView.style.display = "none";
        loggedInView.style.display = "block";
      } else if (lockedView && unlockedView) {
        lockedView.style.display = "none";
        unlockedView.style.display = "block";
      } else if (skeletonLoader && unlockedView) {
        skeletonLoader.style.display = "none";
        unlockedView.style.display = "block";
      }
    }

    handleUserDetailsEvent() {
      setTimeout(() => {
        this.showUnlockedContent();
      }, 300);
    }
  }

  if (!window.customElements.get("cidaas-lock")) {
    window.customElements.define("cidaas-lock", CidaasLock);
  }
}

if (typeof CidaasUnlocked === "undefined") {
  class CidaasUnlocked extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {}
  }

  if (!window.customElements.get("cidaas-unlocked")) {
    window.customElements.define("cidaas-unlocked", CidaasUnlocked);
  }
}

if (typeof CidaasLoggedOut === "undefined") {
  class CidaasLoggedOut extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {}
  }

  if (!window.customElements.get("cidaas-logged-out")) {
    window.customElements.define("cidaas-logged-out", CidaasLoggedOut);
  }
}

if (typeof CidaasLocked === "undefined") {
  class CidaasLocked extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {}
  }

  if (!window.customElements.get("cidaas-locked")) {
    window.customElements.define("cidaas-locked", CidaasLocked);
  }
}

if (typeof CidaasLoggedIn === "undefined") {
  class CidaasLoggedIn extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {}
  }

  if (!window.customElements.get("cidaas-logged-in")) {
    window.customElements.define("cidaas-logged-in", CidaasLoggedIn);
  }
}

if (typeof CidaasSkeleton === "undefined") {
  class CidaasSkeleton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.render();
    }

    render() {
      this.innerHTML = `
            <div class="ds-skeleton-loader">
                <div class="ds-skeleton-header">
                    <div class="ds-skeleton-icon"></div>
                    <div class="ds-skeleton-title"></div>
                </div>
                <div class="ds-skeleton-text"></div>
            </div>
        `;
    }
  }

  if (!window.customElements.get("cidaas-skeleton")) {
    window.customElements.define("cidaas-skeleton", CidaasSkeleton);
  }
}

if (typeof ConsentTextExpand === "undefined") {
  class ConsentTextExpand extends HTMLElement {
    constructor() {
      super();
      this.expandBtn = this.querySelector('.ds-consent-toggle');
      this.content = this.querySelector('.ds-pocc-consent__text');
      this.expanded = false;
      this.clicked = false;
      
      /*this.content.classList.add('collapsed');*/
      
      this.expandBtn.addEventListener('click', () => this.toggleExpand());
      this.addEventListener('click', () => {
        if (!this.clicked) {
          this.clicked = true;
          this.toggleExpand();
        }
      });
    }
    
    toggleExpand() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        //this.content.classList.remove('collapsed');
        setTimeout(() => {
          this.classList.add('expanded');
        }, 300); // Warte auf die Animation, bevor die volle Höhe gesetzt wird
      } else {
        this.classList.remove('expanded');
        setTimeout(() => {
          //this.content.classList.add('collapsed');
        }, 50); // Kurze Verzögerung, um die Höhenänderung abzuschließen
      }
    }
  }

  if (!window.customElements.get("consent-expand")) {
    window.customElements.define("consent-expand", ConsentTextExpand);
  }
}